<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div class="row">
      <form class="b-from col-12">
        <div class="row b-form__row_type_flex-end b-reports__filter-inner">
          <div class="col-2">
            <label>{{$t('CONTENT.reportPage.reports_type')}}:</label>
            <cool-select
              :list="reportTypes"
              option-value="id"
              option-text="displayName"
              :placeholder="$t('CONTENT.choose')"
              v-model="formData.reportType"
            ></cool-select>
          </div>
          <div class="col-1">
            <label>{{$t('CONTENT.contract.lessee')}}:</label>
            <cool-select
              :list="allCounterparties"
              option-value="id"
              option-text="value"
              v-model="lesseeModel"
              :placeholder="$t('CONTENT.choose')"
            ></cool-select>
          </div>
          <div class="col-1">
            <label>{{$t('CONTENT.contract.lessor')}}:</label>
            <cool-select
              :list="allCounterparties"
              option-value="id"
              option-text="value"
              v-model="lessorModel"
              :placeholder="$t('CONTENT.choose')"
            ></cool-select>
          </div>
          <div class="col-1"
               v-if="formData.reportType !== 4 &&
               formData.reportType !== 5 &&
               formData.reportType !== 6 &&
               formData.reportType !== 7 &&
               formData.reportType !== 8 &&
               formData.reportType !== 10">
            <label>{{$t('CONTENT.contract.external_id_contract')}}:</label>
            <cool-select
              :list="allAvailableContracts"
              option-value="idInDB"
              option-text="externalId"
              :placeholder="$t('CONTENT.choose')"
              v-model="externalId"
            ></cool-select>
          </div>
          <div class="col-3" v-if="formData.reportType < 7">
            <div class="row b-form__container_type_flex b-form__row_type_flex-end">
              <div class="col-6 pr-1">
                <div>
                  <label>{{$t('CONTENT.reportPage.reports_period')}}:</label>
                  <datepicker
                    class="b-datepicker"
                    v-model="periodStartDateModel"
                    :disabled-date="disabledDatesForStartDate"
                    :formatter="datepickerFormat"
                  ></datepicker>
                </div>
              </div>
              <div class="col-6 pl-1">
                <div>
                  <datepicker
                    class="b-datepicker"
                    v-model="periodEndDateModel"
                    :disabled-date="disabledDatesForEndDate"
                    :formatter="datepickerFormat"
                  ></datepicker>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3" v-if="formData.reportType == 7 || formData.reportType == 8 || formData.reportType == 10">
            <div>
              <label>{{$t('CONTENT.reportPage.reports_period')}}:</label>
              <datepicker
                class="b-datepicker"
                v-model="periodStartDateModel"
                :disabled-date="disabledDatesForStartDate"
                :formatter="datepickerFormat"
              ></datepicker>
            </div>
          </div>
          <div class="col-3 row" v-if="formData.reportType == 9 || formData.reportType == 11">
            <div class="col-8 row b-form__container_type_flex b-form__row_type_flex-end">
              <div class="col-6">
                <div>
                  <label>{{$t('CONTENT.reportPage.reports_period')}}:</label>
                  <datepicker
                    class="b-datepicker"
                    v-model="periodStartDateModel"
                    :disabled-date="disabledDatesForStartDate"
                    :formatter="datepickerFormat"
                  ></datepicker>
                </div>
              </div>
              <div class="col-6">
                <div>
                  <datepicker
                    class="b-datepicker"
                    v-model="periodEndDateModel"
                    :disabled-date="disabledDatesForEndDate"
                    :formatter="datepickerFormat"
                  ></datepicker>
                </div>
              </div>
            </div>
            <div class="col-4 b-form__container_type_flex b-form__row_type_flex-end">
              <div>
                <label>{{$t('CONTENT.reportPage.take_events_before')}}:</label>
                <datepicker
                  class="b-datepicker"
                  v-model="takeEventsBeforeDateModel"
                  :disabled-date="disabledDatesForTakeEventsBeforeDate"
                  :formatter="datepickerFormat"
                ></datepicker>
              </div>
            </div>
          </div>
          <div class="col-1"
               v-if="formData.reportType !== 4 &&
               formData.reportType !== 5 &&
               formData.reportType !== 6 &&
               formData.reportType !== 7 &&
               formData.reportType !== 8 &&
               formData.reportType !== 10 &&
               formData.reportType !== 11">
            <label>{{$t('CONTENT.contract.contract_number')}}:</label>
            <cool-select
              :list="availableContracts"
              option-value="idInDB"
              option-text="number"
              :placeholder="$t('CONTENT.choose')"
              :isDisabled="isDisabledContractsChoose"
              v-model="contractNumber"
            ></cool-select>
          </div>
          <div class="col-3" v-if="formData.reportType === 7">
            <checkbox
              v-model="formData.withFullAdditionalInfo"
              class="b-checkbox"
            >{{$t('CONTENT.reportPage.addPercentLosses')}}</checkbox>
          </div>
          <div class="col-3" v-if="formData.reportType === 9">
            <checkbox
              v-model="formData.withFullAdditionalInfo"
              class="b-checkbox"
            >{{$t('CONTENT.reportPage.fullAdditionalInformation')}}</checkbox>
          </div>
        </div>
        <div class="row b-form__row_type_flex-end b-reports__filter-actions mt-4">
          <div v-if="formData.reportType !== 8 && formData.reportType !== 7 && formData.reportType !== 10 && formData.reportType !== 11" class="col-1">
            <button
              class="b-btn"
              @click.prevent="onSubmitFilter(false)"
              :disabled="isDisabledSaveBtn"
            >{{$t('CONTENT.reportPage.create_report')}}</button>
          </div>
          <div class="col-1">
            <button
              class="b-btn"
              @click.prevent="onSubmitFilter(true)"
              :disabled="isDisabledSaveBtn"
            >{{$t('CONTENT.reportPage.create_report_excel')}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';
import dateConverter from "../../../utils/converters/date.converter";

export default {
  props: {
    reportTypes: {
      type: Array,
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      error: null,
      formData: {
        reportType: 9,
        lessee: null,
        lessor: null,
        periodStartDate: null,
        periodEndDate: null,
        takeEventsBeforeDate: null,
        contractNumber: null,
        externalId: null,
        withFullAdditionalInfo: false,
      },
      isDisabledSaveBtn: true,
      availableContracts: [],
      allAvailableContracts: []
    };
  },
  computed: {
    ...mapGetters(["getCounterpartiresForContract"]),
    ...mapGetters(["allContractAggregates"]),
    contractNumber: {
      get() {
        return this.formData.contractNumber;
      },
      set(value) {
        this.formData.externalId = -1;
        this.formData.contractNumber = value;
      },
    },
    externalId: {
      get() {
        return this.formData.externalId;
      },
      set(value) {
        this.formData.lessee = -1;
        this.formData.lessor = -1;
        this.formData.contractNumber = -1;
        this.formData.externalId = value;
      },
    },
    allCounterparties() {
      return [{ id: -1, value: "Все" }, ...this.getCounterpartiresForContract];
    },
    isDisabledContractsChoose() {
      return this.formData.lessee === null || (this.formData.lessee === -1 && this.formData.contractNumber === -1);
    },
    periodStartDateModel: {
      get() {
        if (this.formData.periodStartDate !== null) {
          return dateConverter.convertToDate(this.formData.periodStartDate);
        } else {
          return this.formData.periodStartDate;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.formData.periodStartDate = dateConverter.convertToString(newVal);
        } else {
          this.formData.periodStartDate = null;
        }
        this.disabledDatesForEndDate();
      }
    },
    periodEndDateModel: {
      get() {
        if (this.formData.periodEndDate !== null) {
          return dateConverter.convertToDate(this.formData.periodEndDate);
        } else {
          return this.formData.periodEndDate;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.formData.periodEndDate = dateConverter.convertToString(newVal);
          this.formData.takeEventsBeforeDate = dateConverter.convertToString(newVal);
        } else {
          this.formData.periodEndDate = null;
          this.formData.takeEventsBeforeDate = null;
        }
        this.disabledDatesForStartDate();
      }
    },
    takeEventsBeforeDateModel: {
      get() {
        if (this.formData.takeEventsBeforeDate !== null) {
          return dateConverter.convertToDate(this.formData.takeEventsBeforeDate);
        } else {
          return this.formData.takeEventsBeforeDate;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.formData.takeEventsBeforeDate = dateConverter.convertToString(newVal);
        } else {
          this.formData.takeEventsBeforeDate = null;
        }
        this.disabledDatesForTakeEventsBeforeDate();
      }
    },
    lesseeModel: {
      get() {
        return this.formData.lessee;
      },
      set(newVal) {
        this.formData.externalId = -1;
        this.formData.lessee = newVal;
        this.getContractByCounterpartyId(newVal);
      }
    },
    lessorModel: {
      get() {
        return this.formData.lessor;
      },
      set(newVal) {
        this.formData.lessor = newVal;
      }
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        if(newVal.reportType === 7 || newVal.reportType === 8 || newVal.reportType === 10) {
          this.formData.periodEndDate = null;
          this.isDisabledSaveBtn = !(newVal.periodStartDate !== null);
        } else if(newVal.reportType === 4 ||
          newVal.reportType === 5 ||
          newVal.reportType === 6) {
          this.formData.contractNumber = null;
          this.formData.externalId = null;
          this.isDisabledSaveBtn = !(newVal.periodStartDate !== null &&
            newVal.periodEndDate !== null);
        } else {
          this.isDisabledSaveBtn = !(newVal.periodStartDate !== null &&
            newVal.periodEndDate !== null &&
            (newVal.contractNumber !== null || newVal.externalId !== null));
        }
      },
      deep: true
    }
  },
  methods: {
    disabledDatesForStartDate(date) {
      if (this.formData.periodEndDate !== null) {
        return date > dateConverter.convertToDate(this.formData.periodEndDate);
      }
    },
    disabledDatesForEndDate(date) {
      if (this.formData.periodStartDate !== null) {
        return (
          date < dateConverter.convertToDate(this.formData.periodStartDate)
        );
      }
    },
    disabledDatesForTakeEventsBeforeDate (date) {
      if (this.formData.periodStartDate !== null) {
        return (
          date < dateConverter.convertToDate(this.formData.periodStartDate)
        );
      }
    },
    onSubmitFilter(isExcel) {
      let contracts = null;
      let params = null;

      if(this.formData.contractNumber === -1 || this.formData.externalId === -1) {
        contracts = this.availableContracts;
      }

      params = _.cloneDeep(this.formData);
      if (params.externalId !== -1) {
        params.contractNumber = params.externalId;
      }

      if(this.formData.lessee === -1) {
        params.lessee = null;
      }

      if(this.formData.lessor === -1) {
        params.lessor = null;
      }

      if (isExcel) {
        this.$emit("downloadExcelReport", {formData: params, contracts: contracts});
      } else {
        this.$emit("onSetReportsParams", {formData: params, contracts: contracts});
      }
    },
    async getContractByCounterpartyId(lesseeId) {
      if(lesseeId !== -1) {
        this.availableContracts = await this.$store.dispatch(
          "getContractsByLesseeId",
          lesseeId
        );
        this.availableContracts.unshift({ idInDB: -1, number: 'Все', externalId: 'Все' });
        this.formData.contractNumber = null;
      } else {
        this.availableContracts = [];
        this.availableContracts.push({ idInDB: -1, number: 'Все', externalId: 'Все' });
        this.formData.contractNumber = -1;
      }
    },
    async getAllContractDocuments() {
      this.allAvailableContracts = await this.$store.dispatch("getAllContracts" );
      this.allAvailableContracts.unshift({ idInDB: -1, number: 'Все', externalId: 'Все' });
      this.formData.contractNumber = null;
      this.formData.externalId = null;
    }
  },
  beforeMount(){
    this.getAllContractDocuments()
  }
};
</script>
